/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app.index"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as AppSkillsRouteImport } from "./routes/_app.skills"
import { Route as AppRoutinesRouteImport } from "./routes/_app.routines"
import { Route as AppNewRouteImport } from "./routes/_app.new"
import { Route as AppHistoryRouteImport } from "./routes/_app.history"
import { Route as AppConnectorsRouteImport } from "./routes/_app.connectors"
import { Route as AppCompanyRouteImport } from "./routes/_app.company"
import { Route as AppCommandsRouteImport } from "./routes/_app.commands"
import { Route as AppAgentsRouteImport } from "./routes/_app.agents"
import { Route as AppSpacesIndexRouteImport } from "./routes/_app.spaces.index"
import { Route as AppSpacesIdRouteImport } from "./routes/_app.spaces.$id"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AppSkillsRoute = AppSkillsRouteImport.update({
  id: "/skills",
  path: "/skills",
  getParentRoute: () => AppRoute,
} as any)
const AppRoutinesRoute = AppRoutinesRouteImport.update({
  id: "/routines",
  path: "/routines",
  getParentRoute: () => AppRoute,
} as any)
const AppNewRoute = AppNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: "/history",
  path: "/history",
  getParentRoute: () => AppRoute,
} as any)
const AppConnectorsRoute = AppConnectorsRouteImport.update({
  id: "/connectors",
  path: "/connectors",
  getParentRoute: () => AppRoute,
} as any)
const AppCompanyRoute = AppCompanyRouteImport.update({
  id: "/company",
  path: "/company",
  getParentRoute: () => AppRoute,
} as any)
const AppCommandsRoute = AppCommandsRouteImport.update({
  id: "/commands",
  path: "/commands",
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRoute = AppAgentsRouteImport.update({
  id: "/agents",
  path: "/agents",
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesIndexRoute = AppSpacesIndexRouteImport.update({
  id: "/spaces/",
  path: "/spaces/",
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesIdRoute = AppSpacesIdRouteImport.update({
  id: "/spaces/$id",
  path: "/spaces/$id",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/agents": typeof AppAgentsRoute
  "/commands": typeof AppCommandsRoute
  "/company": typeof AppCompanyRoute
  "/connectors": typeof AppConnectorsRoute
  "/history": typeof AppHistoryRoute
  "/new": typeof AppNewRoute
  "/routines": typeof AppRoutinesRoute
  "/skills": typeof AppSkillsRoute
  "/invite/$token": typeof InviteTokenRoute
  "/spaces/$id": typeof AppSpacesIdRoute
  "/spaces/": typeof AppSpacesIndexRoute
}
export interface FileRoutesByTo {
  "/agents": typeof AppAgentsRoute
  "/commands": typeof AppCommandsRoute
  "/company": typeof AppCompanyRoute
  "/connectors": typeof AppConnectorsRoute
  "/history": typeof AppHistoryRoute
  "/new": typeof AppNewRoute
  "/routines": typeof AppRoutinesRoute
  "/skills": typeof AppSkillsRoute
  "/invite/$token": typeof InviteTokenRoute
  "/": typeof AppIndexRoute
  "/spaces/$id": typeof AppSpacesIdRoute
  "/spaces": typeof AppSpacesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/_app/agents": typeof AppAgentsRoute
  "/_app/commands": typeof AppCommandsRoute
  "/_app/company": typeof AppCompanyRoute
  "/_app/connectors": typeof AppConnectorsRoute
  "/_app/history": typeof AppHistoryRoute
  "/_app/new": typeof AppNewRoute
  "/_app/routines": typeof AppRoutinesRoute
  "/_app/skills": typeof AppSkillsRoute
  "/invite/$token": typeof InviteTokenRoute
  "/_app/": typeof AppIndexRoute
  "/_app/spaces/$id": typeof AppSpacesIdRoute
  "/_app/spaces/": typeof AppSpacesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/agents"
    | "/commands"
    | "/company"
    | "/connectors"
    | "/history"
    | "/new"
    | "/routines"
    | "/skills"
    | "/invite/$token"
    | "/spaces/$id"
    | "/spaces/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/agents"
    | "/commands"
    | "/company"
    | "/connectors"
    | "/history"
    | "/new"
    | "/routines"
    | "/skills"
    | "/invite/$token"
    | "/"
    | "/spaces/$id"
    | "/spaces"
  id:
    | "__root__"
    | "/_app"
    | "/_app/agents"
    | "/_app/commands"
    | "/_app/company"
    | "/_app/connectors"
    | "/_app/history"
    | "/_app/new"
    | "/_app/routines"
    | "/_app/skills"
    | "/invite/$token"
    | "/_app/"
    | "/_app/spaces/$id"
    | "/_app/spaces/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/skills": {
      id: "/_app/skills"
      path: "/skills"
      fullPath: "/skills"
      preLoaderRoute: typeof AppSkillsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/routines": {
      id: "/_app/routines"
      path: "/routines"
      fullPath: "/routines"
      preLoaderRoute: typeof AppRoutinesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/new": {
      id: "/_app/new"
      path: "/new"
      fullPath: "/new"
      preLoaderRoute: typeof AppNewRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/history": {
      id: "/_app/history"
      path: "/history"
      fullPath: "/history"
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/connectors": {
      id: "/_app/connectors"
      path: "/connectors"
      fullPath: "/connectors"
      preLoaderRoute: typeof AppConnectorsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/company": {
      id: "/_app/company"
      path: "/company"
      fullPath: "/company"
      preLoaderRoute: typeof AppCompanyRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/commands": {
      id: "/_app/commands"
      path: "/commands"
      fullPath: "/commands"
      preLoaderRoute: typeof AppCommandsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/agents": {
      id: "/_app/agents"
      path: "/agents"
      fullPath: "/agents"
      preLoaderRoute: typeof AppAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/spaces/": {
      id: "/_app/spaces/"
      path: "/spaces"
      fullPath: "/spaces/"
      preLoaderRoute: typeof AppSpacesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/spaces/$id": {
      id: "/_app/spaces/$id"
      path: "/spaces/$id"
      fullPath: "/spaces/$id"
      preLoaderRoute: typeof AppSpacesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAgentsRoute: typeof AppAgentsRoute
  AppCommandsRoute: typeof AppCommandsRoute
  AppCompanyRoute: typeof AppCompanyRoute
  AppConnectorsRoute: typeof AppConnectorsRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppNewRoute: typeof AppNewRoute
  AppRoutinesRoute: typeof AppRoutinesRoute
  AppSkillsRoute: typeof AppSkillsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSpacesIdRoute: typeof AppSpacesIdRoute
  AppSpacesIndexRoute: typeof AppSpacesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgentsRoute: AppAgentsRoute,
  AppCommandsRoute: AppCommandsRoute,
  AppCompanyRoute: AppCompanyRoute,
  AppConnectorsRoute: AppConnectorsRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppNewRoute: AppNewRoute,
  AppRoutinesRoute: AppRoutinesRoute,
  AppSkillsRoute: AppSkillsRoute,
  AppIndexRoute: AppIndexRoute,
  AppSpacesIdRoute: AppSpacesIdRoute,
  AppSpacesIndexRoute: AppSpacesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
